import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const CARDS_KEY = "cards";
const SIDE_LINKS_KEY = "sideLinks";

export const dashboardCardsKeys = createKeys(
  featureKeys.DASHBOARD_CARDS_FEATURE_KEY,
  {
    cards: (networkID) => [CARDS_KEY, networkID],
    sideLinks: () => [SIDE_LINKS_KEY],
  }
);
